import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { initialize, LDClient, LDFlagSet, LDUser } from 'ldclient-js';
import { v4 as uuid } from 'uuid';
import { User } from '@gcv/shared';
import { FeatureFlags } from './ldconstants';
import { LoggerService } from '@user-interface/gcv-ui';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class LaunchDarklyService {
  ldClient: LDClient;
  flags: LDFlagSet;
  flagChange: Subject<object> = new Subject<object>();

  constructor(private logger: LoggerService) {
    this.flags = {};
    const anonymousUser: LDUser = {
      key: uuid(),
      anonymous: true,
    };
    if (environment.gcvConfig.launchDarklyClientSideId) {
      this.ldClient = initialize(environment.gcvConfig.launchDarklyClientSideId, anonymousUser); // FIXME don't use anon
      this.ldClient.on('change', flags => {
        this.setFlag(FeatureFlags.FINCEN_FEATURE_MODULE_BLACKLIST, flags);
        this.flagChange.next(this.flags);
        this.logger.log('Flags updated.');
      });

      this.ldClient.on('ready', () => {
        this.setFlags();
      });
    }
  }

  static accountForNullArray(flag: any) {
    return flag ? flag : [];
  }

  static isFincenFeatureModuleDisabled(flags: any, bankId: string) {
    const flag = flags[FeatureFlags.FINCEN_FEATURE_MODULE_BLACKLIST].current
      ? flags[FeatureFlags.FINCEN_FEATURE_MODULE_BLACKLIST].current
      : flags[FeatureFlags.FINCEN_FEATURE_MODULE_BLACKLIST];
    const fincenFeatureModuleBlacklist = LaunchDarklyService.accountForNullArray(flag);
    let isBlacklisted;
    if (fincenFeatureModuleBlacklist && fincenFeatureModuleBlacklist.includes) {
      isBlacklisted = fincenFeatureModuleBlacklist.includes(bankId);
    } else {
      isBlacklisted = false;
    }
    return isBlacklisted;
  }

  setFlags() {
    this.flags = this.ldClient.allFlags(); // FIXME don't get all flags
    this.logger.log('Flags set.');
  }

  changeUser(
    isAnonymous: boolean,
    user: User,
    hash?: string,
    onDone?: (err: Error | null, flags: LDFlagSet | null) => void
  ) {
    if (isAnonymous) {
      const anonymousUser: LDUser = {
        key: uuid(),
        anonymous: true,
      };
      this.ldClient.identify(anonymousUser);
    } else {
      const launchDarklyUser: LDUser = {
        key: user.id,
        anonymous: false,
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        name: user.firstName + ' ' + user.lastName,
      };
      this.ldClient.identify(launchDarklyUser, hash, onDone);
    }
  }

  setFlag(flagName, flags) {
    if (flags[flagName] !== undefined) {
      this.flags[flagName] = flags[flagName];
    }
  }
}

// Example Usage

/*

constructor(private ld: LaunchDarkleyService) {
  this.gs450 = ld.flags[FeatureFlags.GS_450];
  this.flagSug = ld.flagChange.subscribe(flags => {
    this.gs450 = flags[FeatureFlags.GS_450].current;
  });
}

*/
